import { Stack } from "@mui/material";
import { useGenericModal } from "src/components/reusable/components/GenericModal";
import { IconCircle } from "./IconCircle";
import { SSText } from "src/components/base/components/SSText";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { throttleTime } from "src/utils/utils";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

export function useRedeemSuccessModal() {
  const theme = useSSTheme();
  const genericModal = useGenericModal();
  const router = useRouterExt();
  const teamConfig = useTeamConfig();
  const REDEEM_SUCCESS_MODAL = teamConfig?.REDEEM_GIFT_PAGE_SETTINGS?.REDEEM_SUCCESS_MODAL; // prettier-ignore

  const close = async (ev?: any) => {
    genericModal.set({ isOpen: false });
    throttleTime(500, () => {
      genericModal.reset();
    });
  };

  const open = () => {
    const onClose = async () => {
      close();
      await router.pushSchema(routes?.home);
    };

    genericModal.set({
      isOpen: true,
      title: "Gift Redeemed",
      hideTitleIcon: true,

      description: (
        <Stack spacing={2} alignItems="center" textAlign="center">
          <IconCircle />
          <SSText variant="h4" lineHeight={1.3} fontWeight={700}>
            {REDEEM_SUCCESS_MODAL?.TITLE || "Congrats!"}
          </SSText>
          <SSText
            variant="body"
            fontSize={`1.1rem`}
            lineHeight={1.4}
            color={theme.mui.palette.grey[700]}
          >
            {REDEEM_SUCCESS_MODAL?.DESCRIPTION ||
              "Your gift has been redeemed successfully. Go to your upcoming events to check the next events."}
          </SSText>
        </Stack>
      ),
      isCloseButtonHidden: true,
      confirmButtonText: "Go to Upcoming Events",
      onClickConfirm: onClose,
      closeIconProps: {
        onClick: onClose,
      },
      confirmButtonProps: {
        size: "large",
        style: { minWidth: "100%", textTransform: "capitalize" as any },
      },
    });
  };

  return {
    open,
    close,
  };
}
